import React from "react";
import OwlCarousel from "react-owl-carousel";

export default function Screenshot({ hasBg }) {
  const options = {
    loop: true,
    margin: 0,
    center: true,
    dots: true,
    nav: false,
    autoplay: true,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 3,
      },
      991: {
        items: 4,
      },
      1200: {
        items: 4,
      },
      1920: {
        items: 4,
      },
    },
  };
  return (
    <>
      <section
        id="screenshots"
        className={`screenshots-section ptb-100 ${
          hasBg ? "gray-light-bg" : ""
        }`}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="section-heading text-center">
                {hasBg ? (
                  <span className="text-uppercase color-secondary sub-title">
                    Fotos de nuestros destinos
                  </span>
                ) : (
                  ""
                )}
                <h2>Destinos</h2>
                <p className="lead">
                  Lo hacemos unico!
                </p>
              </div>
            </div>
          </div>
          <div className="screen-slider-content mt-5">
            <div className="screenshot-frame"></div>
            <OwlCarousel
              className="screen-carousel owl-carousel owl-theme dot-indicator"
              {...options}
            >
              <img
                src="assets/img/landing/imagen1.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/landing/imagen2.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/landing/imagen3.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/landing/imagen4.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/landing/imagen5.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/landing/imagen6.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/landing/imagen7.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/landing/imagen8.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/landing/imagen9.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/landing/imagen10.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/landing/imagen11.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/landing/imagen12.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/landing/imagen13.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/landing/imagen14.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/landing/imagen15.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/landing/imagen16.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/landing/imagen17.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/landing/imagen18.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/landing/imagen19.jpg"
                className="img-fluid"
                alt="screenshots"
              />
                            <img
                src="assets/img/landing/imagen20.jpg"
                className="img-fluid"
                alt="screenshots"
              />
            </OwlCarousel>
          </div>
        </div>
      </section>
    </>
  );
}
